import { AnswerModel, interstitialAnswer } from '@/components/decision-tree/hooks';
import { TOAST_DEFAULT_OPTIONS } from '@/constants/toast';
import { getInterstitialImageId } from '@/utils';
import { useBreakpointValue, useToast } from '@cmpsr/components';
import { useEffect, useState } from 'react';
import { ImageInterstitialType } from './types';

export const useImageInterstitialController = ({
  saveAnswer,
  data,
  goToNextSurveyItem,
}: {
  saveAnswer: (answer: AnswerModel) => void;
  data: ImageInterstitialType;
  goToNextSurveyItem: () => void;
}) => {
  const [lastAnswered, setlastAnswered] = useState<string | null>(null);
  const [isLoading, setIsloading] = useState<boolean>(false);
  const toast = useToast();

  useEffect(() => {
    if (lastAnswered !== data.id) {
      setlastAnswered(data.id);
      saveAnswer(interstitialAnswer);
    }
  }, [data.id]);

  const imageId = getInterstitialImageId(data.resource);

  const handleNextClick = async () => {
    setIsloading(true);
    try {
      await goToNextSurveyItem();
    } catch (error) {
      toast({
        ...TOAST_DEFAULT_OPTIONS,
        title: 'Error',
        description: error,
        status: 'error',
      });
      setIsloading(false);
    }
    setIsloading(false);
  };

  const buttonLabel = useBreakpointValue({ base: "Let's Go", md: 'Continue' }, { ssr: false });

  return { ...data, imageId, handleNextClick, isLoading, buttonLabel };
};
